module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "consultations-header"
  }, [_c('Header', [_vm._v("Консультации")])], 1), _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('div', [_c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  })], 1) : [(_vm.hasItems) ? [(_vm.isCaruselData) ? _c('Slider', {
    attrs: {
      "items": _vm.caruselData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_data = ref.data;
        var info = ref_data.info;
        var upperIndex = ref_data.index;

        return _vm._l((info), function(item, index) {
          return _c('ConsultationItem', {
            key: item.id,
            attrs: {
              "items": item
            }
          })
        })
      }
    }], null, false, 663083356)
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('ConsultationItem', {
      key: item.id,
      attrs: {
        "items": item
      }
    })
  })] : _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("В данном разделе пока нет данных.")])])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344088cf","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/consultations/Consultatations.vue
// module id = da654a1a2c6871142880
// module chunks = 89